import { Create, TopToolbar } from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateUniversityForm = () => {
  return (
    <SecuredComponent permission={permissions.canManageExternalUniversities}>
      <Create
        title="Създай университет"
        actions={
          <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
            <BackButtonToolbar />
          </TopToolbar>
        }
      >
        <SaveForm />
      </Create>
    </SecuredComponent>
  );
};
export default CreateUniversityForm;
